/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface TreatmentCategoryWithTreatmentCaution {
  /** 치료 태그 아이디 */
  _id: string;
  /** 고객유형(치료유형) 명칭 */
  categoryName: string;
  /** 병원ID */
  hospitalID: string;
  /**
   * 정렬순서
   * @default 9999
   */
  sortNum?: number;
  /** Colorpalette 모델의 basicPalette 인덱스 */
  paletteIndex?: number;
  /** 치료시 주의사항 treatmentCaution */
  treatmentCautionID: TreatmentCaution;
  /**
   * 삭제 여부를 나타내는 플래그
   * @default false
   */
  isRemoved?: boolean;
  /** 커스텀 색상 사용 여부 - true일 경우 customColor 필드 필수 */
  isUsingCustomColor?: boolean;
  /**
   * 커스텀 색상 코드 - isUsingCustomColor가 true 가 아닌데 값이 들어있으면 오류 발생
   * @example "#FFFFFF"
   */
  customColor?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface TreatmentCaution {
  /** 치료 주의사항 아이디 */
  _id: string;
  /** 해당 유의사항을 사용하는 병원의 ID */
  hospitalID: string;
  /** 치료유형 선택시 채팅으로 전달될 이미지 파일ID 목록 */
  fileIDs?: string[];
  /** 내용을 최초 작성한 사용자의 ID */
  writerID: string;
  /** 마지막으로 수정한 사용자의 ID */
  modifierID?: string;
  /** 삭제 여부 플래그 */
  isRemoved?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface TreatmentCategory {
  /** 치료 태그 아이디 */
  _id: string;
  /** 고객유형(치료유형) 명칭 */
  categoryName: string;
  /** 병원ID */
  hospitalID: string;
  /**
   * 정렬순서
   * @default 9999
   */
  sortNum?: number;
  /** Colorpalette 모델의 basicPalette 인덱스 */
  paletteIndex?: number;
  /** 치료시 주의사항 treatmentCaution 아이디 */
  treatmentCautionID?: string;
  /**
   * 삭제 여부를 나타내는 플래그
   * @default false
   */
  isRemoved?: boolean;
  /** 커스텀 색상 사용 여부 - true일 경우 customColor 필드 필수 */
  isUsingCustomColor?: boolean;
  /**
   * 커스텀 색상 코드 - isUsingCustomColor가 true 가 아닌데 값이 들어있으면 오류 발생
   * @example "#FFFFFF"
   */
  customColor?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface TreatmentTag {
  /** 태그 고유 ID */
  tagId: string;
  /** 태그 이름 */
  name: string;
  /** 태그 색상 (Hex 코드) */
  color?: string;
  /** 자동화 알고리즘 적용 여부 */
  automationApplied?: boolean;
  /** 폴더 ID */
  folderID?: string;
  appliedAt?: string;
  /** 세종병원 연동 전용 진단 코드 */
  mappedDiagnosisCode?: string;
  /** 세종병원 연동 전용 치료 태그 수정 여부 */
  isEditable?: boolean;
}

export interface MultipleTreatmentTagCreationHandlerBodyRequest {
  /** 다량의 치료 태그 생성 요청 */
  tags: {
    /**
     * 고객 유형(치료 유형) 명칭
     * @example "체외충격파"
     */
    categoryName: string;
    /**
     * 병원의 ObjectId
     * @example "60efb98ebc1545e15c1e5e2d"
     */
    hospitalID: string;
    /**
     * Colorpalette 모델의 basicPalette 인덱스 - isUsingCustomColor가 false일 경우 필수
     * @example 4
     */
    paletteIndex?: number;
    /**
     * 커스텀 색상 사용 여부 - true일 경우 customColor 필드 필수
     * @default false
     * @example false
     */
    isUsingCustomColor: boolean;
    /**
     * 커스텀 색상 코드 - isUsingCustomColor가 true 가 아닌데 값이 들어있으면 오류 발생
     * @example "#EF5252"
     */
    customColor?: string;
  }[];
}

export interface MultipleTreatmentTagCreationHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 치료 태그 다량 생성 성공 여부 */
    isCreatedSuccess: True;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

/** 치료 태그 다량 생성 성공 여부 */
export type True = boolean;

export interface ApiTreatmentTagsElFindParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 삭제 플래그 */
  isRemoved?: boolean;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiTreatmentTagsElFindData = ApiResponse & {
  data: TreatmentCategoryWithTreatmentCaution[];
};

export type ApiTreatmentTagsElCreateData = ApiResponse & {
  data: TreatmentCategory;
};

export type ApiTreatmentTagsElUpdateData = ApiResponse & {
  data: TreatmentCategory;
};

export type ApiTreatmentTagsElRemoveData = ApiResponse & {
  data: TreatmentCategory;
};

export interface ApiTreatmentTagsElParams {
  /** 병원 ID */
  hospitalID: string;
  /** 커서 (patientId). 최초 호출 이후 응답 값에 nextCursor 값이 주어집니다. */
  cursor?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
}

export type ApiTreatmentTagsElData = ApiResponse & {
  data: {
    /** 다음 커서 ID */
    nextCursorId?: string;
    /** 치료 태그 목록 */
    treatmentTags?: (TreatmentTag & {
      automationApplied?: any;
    })[];
  };
};

export type MultipleTreatmentTagCreationHandlerData = MultipleTreatmentTagCreationHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-TreatmentTag
     * @name ApiTreatmentTagsElFind
     * @summary 병원별 치료 태그 조회
     * @request GET:/v3/api/treatment-tags/el/find
     * @secure
     * @response `200` `ApiTreatmentTagsElFindData` 병원별 치료 태그 조회 성공
     */
    apiTreatmentTagsElFind: (query: ApiTreatmentTagsElFindParams, params: RequestParams = {}) =>
      this.request<ApiTreatmentTagsElFindData, any>({
        path: `/v3/api/treatment-tags/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-TreatmentTag
     * @name ApiTreatmentTagsElCreate
     * @summary 치료 태그 신규 생성
     * @request POST:/v3/api/treatment-tags/el/create
     * @secure
     * @response `200` `ApiTreatmentTagsElCreateData` 치료 태그 생성 성공
     */
    apiTreatmentTagsElCreate: (
      data: {
        /** 고객 유형(치료 유형) 명칭 */
        categoryName: string;
        /** 병원의 ObjectId */
        hospitalID: string;
        /** 치료시 주의사항 treatmentCaution 아이디 */
        treatmentCautionID?: string;
        /** Colorpalette 모델의 basicPalette 인덱스 - isUsingCustomColor가 false일 경우 필수 */
        paletteIndex?: number;
        /**
         * 커스텀 색상 사용 여부 - true일 경우 customColor 필드 필수
         * @default false
         */
        isUsingCustomColor: boolean;
        /**
         * 커스텀 색상 코드 - isUsingCustomColor가 true 가 아닌데 값이 들어있으면 오류 발생
         * @example "#FFFFFF"
         */
        customColor?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiTreatmentTagsElCreateData, any>({
        path: `/v3/api/treatment-tags/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-TreatmentTag
     * @name ApiTreatmentTagsElUpdate
     * @summary 치료 태그 수정
     * @request POST:/v3/api/treatment-tags/el/update
     * @secure
     * @response `200` `ApiTreatmentTagsElUpdateData` 치료 태그 수정 성공
     */
    apiTreatmentTagsElUpdate: (
      data: {
        /**
         * 업데이트 할 고객 유형(치료 유형) ObjectId
         * @example "66ac5bae07a37e99d4ae628d"
         */
        tcID: string;
        /**
         * 고객 유형(치료 유형) 명칭
         * @example "치료 태그 명칭"
         */
        categoryName?: string;
        /**
         * 병원의 ObjectId
         * @example "63d7bafc1374672f7c407efd"
         */
        hospitalID: string;
        /**
         * 폴더 ID - 치료 태그가 소속된 폴더를 신규로 추가하거나 수정할 때 필수 - 치료 태그 순서는 변경하고 싶은데 특정 폴더에 넣고 싶지 않다면 null로 설정 필수
         * @example "66ac4be507a37e99d4ae626a"
         */
        folderID?: string;
        /**
         * 이전 치료 태그의 정렬 순서 - 가장 상단에 위치하게 하려면 null로 설정
         * @example 2
         */
        beforeTreatmentTagSortNum?: number;
        /**
         * 치료 태그를 가장 상단에 위치하게 하려면 true로 설정
         * @example true
         */
        toBeSortedHighest?: boolean;
        /** 치료시 주의사항 treatmentCaution 아이디 */
        treatmentCautionID?: string;
        /** Colorpalette 모델의 basicPalette 인덱스 */
        paletteIndex?: number;
        /**
         * 치료 태그 활성화 여부 - 치료 태그 활성화/비활성화 요청 시 필수
         * @default true
         */
        isActive?: boolean;
        /**
         * 삭제 여부를 나타내는 플래그
         * @default false
         */
        isRemoved?: boolean;
        /**
         * 커스텀 색상 사용 여부 - true일 경우 customColor 필드 필수
         * @default false
         */
        isUsingCustomColor?: boolean;
        /**
         * 커스텀 색상 코드 - isUsingCustomColor가 true 가 아닌데 값이 들어있으면 오류 발생
         * @example "#FFFFFF"
         */
        customColor?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiTreatmentTagsElUpdateData, any>({
        path: `/v3/api/treatment-tags/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-TreatmentTag
     * @name ApiTreatmentTagsElRemove
     * @summary 치료 태그 삭제
     * @request POST:/v3/api/treatment-tags/el/remove
     * @secure
     * @response `200` `ApiTreatmentTagsElRemoveData` 치료 태그 삭제 성공
     */
    apiTreatmentTagsElRemove: (
      data: {
        /** 삭제할 고객 유형(치료 유형) ObjectId */
        tcID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiTreatmentTagsElRemoveData, any>({
        path: `/v3/api/treatment-tags/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 병원의 치료 태그 리스트를 조회합니다.
     *
     * @tags V3-TreatmentTag
     * @name ApiTreatmentTagsEl
     * @summary 치료 태그 리스트 조회 API
     * @request GET:/v3/api/treatment-tags/el
     * @secure
     * @response `200` `ApiTreatmentTagsElData` 치료 태그 리스트 조회 성공
     */
    apiTreatmentTagsEl: (query: ApiTreatmentTagsElParams, params: RequestParams = {}) =>
      this.request<ApiTreatmentTagsElData, any>({
        path: `/v3/api/treatment-tags/el`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 다량의 치료 태그 데이터를 생성합니다.
     *
     * @tags V3-TreatmentTag
     * @name MultipleTreatmentTagCreationHandler
     * @summary 다량의 치료 태그 데이터 생성
     * @request POST:/v3/api/treatment-tags/el/multiple
     * @secure
     * @response `200` `MultipleTreatmentTagCreationHandlerData` success
     */
    multipleTreatmentTagCreationHandler: (
      data: MultipleTreatmentTagCreationHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<MultipleTreatmentTagCreationHandlerData, any>({
        path: `/v3/api/treatment-tags/el/multiple`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
